import * as type from '../../types/API/settingTypes'

export function updateSetting(payload: any) {
    return {
        type: type.UPDATE_SETTING,
        payload: payload
    }
}

export function getSetting(payload: any) {
    return {
        type: type.GET_SETTING,
        payload: payload
    }
}

